export default function AboutCTA() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[420px]">
      <div className="lg:w-1/2 relative min-h-[300px] lg:min-h-[500px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20anime%20illustration%20of%20a%20creative%20studio%20workspace%20with%20manga%20drawing%20tools%2C%20sketchbooks%2C%20and%20inspirational%20art%20on%20walls%2C%20soft%20natural%20light%2C%20cozy%20creative%20atmosphere%2C%20watercolor%20style%2C%20terracotta%20and%20cream%20tones&width=960&height=1200&seq=about-cta-01&orientation=portrait"
          alt="商务合作 - 178漫画网"
          title="178漫画网商务合作 - 共创漫画未来"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
        <span className="absolute top-6 left-6 text-xs font-medium text-white/80 bg-black/20 px-3 py-1.5 rounded-full backdrop-blur-sm">
          商务合作
        </span>
        <div className="absolute bottom-8 left-6 right-6">
          <p className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight">
            共创
          </p>
          <p className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight">
            漫画
          </p>
          <p className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight">
            未来
          </p>
        </div>
      </div>

      <div className="lg:w-1/2 flex items-center justify-center px-6 md:px-12 py-12 bg-background-50">
        <div className="max-w-md text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            联系我们
          </h2>
          <p className="mt-5 text-foreground-600 leading-relaxed text-sm md:text-base">
            178漫画网欢迎各类合作，包括版权合作、广告投放、作者入驻等。我们拥有千万级用户基础和优质的漫画内容生态，期待与您携手共创漫画产业的未来。
          </p>

          <div className="mt-8 flex flex-col gap-3 text-sm text-foreground-600">
            <div className="flex items-center justify-center gap-2">
              <i className="ri-mail-line text-primary-600" />
              <span>hello@kiyvx.cn</span>
            </div>
            <div className="flex items-center justify-center gap-2">
              <i className="ri-phone-line text-primary-600" />
              <span>400-178-0000</span>
            </div>
            <div className="flex items-center justify-center gap-2">
              <i className="ri-map-pin-line text-primary-600" />
              <span>北京市朝阳区漫画产业园区A座</span>
            </div>
          </div>

          <a
            href="mailto:hello@kiyvx.cn"
            className="mt-8 inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-900 text-white text-sm md:text-base font-medium hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            发送邮件 <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}